import type { MissingFieldsData } from '@/state/navigation';
import { computeMissingContactFields } from '../shared/missingFields';
import { buildContactsSchema } from '../shared/schema';
import type { ContactsFormData, ContactType } from '../shared/types';
import { listingContactRequiredFields } from './formConfig';

const ROLE_LABELS: Record<ContactType, string> = {
  agent: "Seller's Agent",
  client: 'Seller',
  counterpartyAgent: "Buyer's Agent",
  counterpartyClient: 'Buyer',
  counterpartyTransactionCoordinator: "Buyer's Transaction Coordinator",
  titleOfficer: 'Title Officer',
  escrowOfficer: 'Escrow Officer',
  lender: 'Lender',
  appraiser: 'Appraiser',
  attorney: "Seller's Attorney",
  counterpartyAttorney: "Buyer's Attorney",
  closingAttorney: 'Closing Attorney',
  propertyManagingAgent: 'Property Managing Agent',
  homeWarranty: 'Home Warranty',
  other: 'Other Contact',
};

export function computeMissingListingContactFields(
  formData: ContactsFormData,
): MissingFieldsData[] {
  const schema = buildContactsSchema(listingContactRequiredFields);
  return computeMissingContactFields(formData, {
    schema,
    roleLabels: ROLE_LABELS,
  });
}
